export default "__VITE_ASSET__d1cb2eea__"